import { filter, map, pairwise } from 'rxjs';

import { createStore } from '../../lib/create-store';

import { reducer } from './reducer';
import { initialState } from './initial-state';

export const commonStore = createStore({
  name: 'commonStore',
  initialState,
  reducer,
});

/**
 * Get the partial common store in order to subscribe just to one key
 * @param {String} key
 * @returns a partial store to be subscribed
 */
export const getCommonStorePartial = (key) =>
  commonStore.pipe(
    pairwise(),
    filter(([prevState, currentState]) => prevState[key] !== currentState[key]),
    map(([, currentState]) => currentState[key])
  );

export { actions as commonActions } from './actions';
